!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("jquery"), require("js-datepicker")) : "function" == typeof define && define.amd ? define(["jquery", "js-datepicker"], t) : "object" == typeof exports ? exports.brookside = t(require("jquery"), require("js-datepicker")) : e.brookside = t(e.jquery, e["js-datepicker"]);
}(window, function (e, t) {
  return function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 2);
  }([function (t, n) {
    t.exports = e;
  }, function (e, n) {
    e.exports = t;
  }, function (e, t, n) {
    "use strict";

    n.r(t);
    var r = n(0),
      o = n.n(r),
      i = n(1),
      u = n.n(i),
      a = function (e) {
        var t = u()(e, {
            formatter: function (e, t, n) {
              e.value = t.toLocaleDateString("en-US");
            }
          }),
          n = function (e) {
            var n,
              r = o()(e).val().split("/");
            if ((n = r[2]) && n.match(/^[0-9]{4}$/) && function (e) {
              return e && e.match(/^[0-9]{1,2}$/);
            }(r[0]) && function (e) {
              return e && e.match(/^[0-9]{1,2}$/);
            }(r[1])) {
              var i = new Date(parseInt(r[2]), parseInt(r[0]) - 1, parseInt(r[1]));
              t.navigate(i), t.setDate(i);
            }
          };
        n(e), o()(e).on("keyup", function (e) {
          var t,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 200;
          return function () {
            for (var r = arguments.length, o = new Array(r), i = 0; i < r; i++) o[i] = arguments[i];
            clearTimeout(t), t = setTimeout(function () {
              e.apply(void 0, o);
            }, n);
          };
        }(function (e) {
          n(e.target);
        }));
      };
    o()(function () {
      var e = o()(".brookside-engine").find("#soil-permit-form");
      if (e.length) {
        var t = e.find("#usda_soil_permit_effective_start_date"),
          n = e.find("#usda_soil_permit_effective_end_date");
        a(t.get(0)), a(n.get(0));
      }
    }), o()(function () {
      var e = o()(".brookside-engine").find("#quarantine-shipping-label-form");
      if (e.length) {
        var t = e.find("#usda_quarantine_shipping_label_expiration_date");
        a(t.get(0));
      }
    });
  }]);
});